import React from 'react'
import { MarketListCardSkeleton } from '@/features/market/market-list-template/MarketListCardSkeleton'
import MarketListHeader from '@/features/market/market-list-header/MarketListHeader'

export default function FeedLoadingSkeleton({ cards = 12 }) {
  const cardList = Array.from({ length: cards })

  return (
    <>
      {/* Same header/filter loading state as MarketListTemplate */}
      <MarketListHeader  />

      {/* Same wrapper and column spacing as MarketListTemplate */}
      <div className="market-page__wrapper !px-4 md:!px-[18px] !mb-0 pb-20 md:pb-16">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 min-[1900px]:grid-cols-5">
          {cardList.map((_, idx) => (
            <MarketListCardSkeleton key={idx} index={idx} />
          ))}
        </div>
      </div>
    </>
  )
}

